import { Component } from 'react';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { inject, observer } from 'mobx-react';

import withLocalization from '~/hoc/withLocalization';
import Button from '../../../components/CustomButton/CustomButton.jsx';
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';
import { Textarea } from '../../../elements/Input';
import { shortDateFormat, timeFormat, totalTimeFormat } from '~/utils/dateFormat';
import { getTimeBankTotalsFromData, getTimebankNormalHours } from '../../../utils/commonMethods.js';

class ConfirmTimesheetModal extends Component {
    constructor(props) {
        super(props);
        this.state = { overtimeComment: '' };
    }

    componentDidUpdate(prevProps) {
        const timelogId = this.props.timelog && this.props.timelog.id;
        const prevTimelogId = prevProps.timelog && prevProps.timelog.id;
        if (this.props.show && (!prevProps.show || prevTimelogId !== timelogId))
            this.setState({ overtimeComment: (this.props.timelog && this.props.timelog.overtime_comment) || '' });
    }

    render() {
        const { t, show, onClose, onConfirm, timelog, commonStore, isUnconfirm } = this.props;
        if (!timelog) return null;
        const dateTimeRules = commonStore.getDateTimeRules();
        const basicRules = commonStore?.config?.client?.data?.basicRules || null;
        const allowTimeBank = basicRules?.timeBankSettings?.allowTimeBank || false;
        const allowAutomaticFlexitimeTimeBank = basicRules?.timeBankSettings?.allowAutomaticFlexitimeTimeBank;
        const title = t('Timesheet Confirmation');
        const btnLabel = isUnconfirm ? t('Reset Confirmation') : t('Confirm');

        const data_array = timelog.data ? [timelog.data] : [];
        const timeBankTotal = allowTimeBank && data_array.length ? getTimeBankTotalsFromData(data_array) : null;
        const { totalNormalMinsAll } = allowTimeBank && data_array.length ? getTimebankNormalHours(data_array) : { totalNormalMinsAll: 0 };
        const totalHours = allowTimeBank
            ? (timelog.status !== 'approved' ? (Number(timeBankTotal) || 0) : Math.max(0, Number(timeBankTotal) || 0))
            + (timelog.status !== 'approved' ? (Number(timelog.total_hours_normal) - Number(totalNormalMinsAll) || 0) : (Number(timelog.total_hours_normal) || 0))
            + (Number(timelog.total_hours_overtime) || 0)
            : timelog.total_hours_normal;

        return (
            <Modal show={show} onHide={onClose} centered size="lg" backdrop="static">
                <Modal.Header>
                    <Modal.Title className="w-100 text-center ApproveModal__title m-0">
                        {title}
                    </Modal.Title>
                    <img
                        src={CloseModalIcon}
                        className="cursor-pointer"
                        alt="close icon"
                        onClick={onClose}
                    />
                </Modal.Header>
                <Modal.Body>
                    <table className="table align-middle mb-0" style={{ backgroundColor: '#eef2f7' }}>
                        <thead>
                            <tr>
                                <th className="fw-semibold">{t('Project')}</th>
                                <th className="fw-semibold">{t('Task')}</th>
                                <th className="fw-semibold">{t('Date')}</th>
                                <th className="fw-semibold">{t('Time')}</th>
                                <th className="fw-semibold">{t('Break')}</th>
                                <th className="fw-semibold">{t('Total Hours')}</th>
                                <th className="fw-semibold">{allowTimeBank ? `${t('OT')} | ${t('TB')}` : t('Overtime')}</th>
                            </tr>
                        </thead>
                        <tbody style={{ backgroundColor: '#ffffff' }}>
                            <tr>
                                <td>{timelog.project_name || '-'}</td>
                                <td>{timelog.task_name || '-'}</td>
                                <td>{shortDateFormat(timelog.for_date, dateTimeRules)}</td>
                                <td>{timeFormat(timelog.from, dateTimeRules)} - {timeFormat(timelog.to, dateTimeRules)}</td>
                                <td>{totalTimeFormat(timelog.break, dateTimeRules)}</td>
                                <td>{totalTimeFormat(totalHours, dateTimeRules)}</td>
                                <td>
                                    {allowTimeBank ? (
                                        <div className="d-flex justify-content-center align-items-center">
                                            {timelog.is_manually_managed &&
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip-top">
                                                            {allowAutomaticFlexitimeTimeBank ? t('Mandatory overtime/flexitime') : t('Mandatory overtime')}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <i className="fa fa-info-circle text-info me-1" aria-hidden="true"></i>
                                                </OverlayTrigger>
                                            }
                                            <div className="text-center" style={{ fontSize: '10px', lineHeight: '10px' }}>
                                                {timelog.total_hours_overtime ? totalTimeFormat(timelog.total_hours_overtime, dateTimeRules) : <span>-</span>}
                                            </div>
                                            &nbsp;|&nbsp;
                                            <div className="text-center" style={{ fontSize: '10px', lineHeight: '10px' }}>
                                                {timeBankTotal ? totalTimeFormat(timeBankTotal, dateTimeRules) : '-'}
                                            </div>
                                        </div>
                                    ) : (
                                        timelog.total_hours_overtime ? totalTimeFormat(timelog.total_hours_overtime, dateTimeRules) : '-'
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {timelog.showOvertimeComment &&
                        <div className="mt-3">
                            <div className="mt-1 mb-2 d-flex align-items-center">
                                <span className="input-block__label">{t('Overtime Comment')}</span>
                                <div>
                                    {timelog.isOvertimeCommentMissing &&
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-top">
                                                    {t('Comment for overtime is missing')}
                                                </Tooltip>
                                            }
                                        >
                                            <i className="fa fa-exclamation-triangle text-warning ms-2" aria-hidden="true"></i>
                                        </OverlayTrigger>
                                    }
                                </div>
                            </div>
                            <Textarea
                                className={'overtime-comment-box'}
                                value={this.state.overtimeComment}
                                style={{ width: '100%' }}
                                placeholder={t('Add comment for overtime')}
                                disabled={isUnconfirm}
                                onChange={(e) => this.setState({ overtimeComment: e.target.value })}
                            />
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <OverlayTrigger placement="top" overlay={<Tooltip>{isUnconfirm ? t('Reset Confirmation') : t('Confirm Timesheet')}</Tooltip>}>
                        <Button fill onClick={() => onConfirm(timelog.user_id, timelog.for_date, timelog.id, this.state.overtimeComment.trim())}>{btnLabel}</Button>
                    </OverlayTrigger>
                    <Button onClick={onClose}>{t('Cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default inject('commonStore')(withLocalization(observer(ConfirmTimesheetModal)));
